
import { defineComponent } from 'vue';
import VehicleItem from './VehicleItem.vue';
import { getVehicleList } from '@/api/apis';
import Banner from '@/components/banner/Banner.vue';

export default defineComponent({
  name: 'Vehicle',
  components: {
    VehicleItem,
    Banner
  },
  data() {
    return {
      loading: false,
      loaded: false,
      vehicles: [],
      pageNo: 1,
      pageSize: 6,
      pageSizeOptions: ['6', '12'],
      current: 1,
      total: 0
    };
  },
  created() {
    this.loadData();
  },
  methods: {
    async loadData() {
      this.loading = true;
      const res = await getVehicleList({
        pageNo: this.pageNo,
        pageSize: this.pageSize
      });

      if (res.success) {
        this.total = res.result.total;

        this.vehicles = res.result.records;
      }

      this.loading = false;
      this.loaded = true;
    },
    onShowSizeChange() {
      this.pageNo = 1;
      this.loadData();
    },
    onChange() {
      this.loadData();
    }
  }
});
